<template>
    <form class="search">
        <div class="search__inner">
            <input type="text" class="search__text" :placeholder="placeholder" @focus="activateSearchText(true)" @blur="activateSearchText(false)">
            <i class="zmdi zmdi-search search__helper" data-ma-action="search-close"></i>
        </div>
    </form>
</template>

<script>

    export default {
        props : {
            placeholder : String
        },
        methods: {
            activateSearchText (status){
                let element = $(this.$el);

                if(status){
                    element.addClass('search--focus');
                }else {
                    element.val('');
                    element.removeClass('search--focus');
                }
            }
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/_searchbox.scss";</style>